module.exports = __webpack_public_path__ + "static/Revenant-9cf1df52258d263b08410000e10753fe.jpg";